module.exports = __webpack_public_path__ + "img/dyh.a48f5cab.jpg";